import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import ButtonComponent from "../Button/Button";
import SelectComponent from "../SelectComponent/SelectComponent";
import InputComponent from "../InputComponent/InputComponent";
import "./enterDetailsPopup.css";
import {
  validateEmail,
  validateMobileNumber,
  validateName,
} from "../../utils/validation";
import Contents from "../../constants/Contents.json";

const EnterDetailsPopup = ({ show, setShow, onClick, popupUserDetails }) => {
  const {
    name,
    setName,
    phone,
    setPhone,
    email,
    setEmail,
    comments,
    setComments,
    selectedState,
    setSelectedState,
    selectedCity,
    setSelectedCity,
  } = popupUserDetails;

  const handleClose = () => {
    setErrors({
      name: "",
      phone: "",
      email: "",
      state: "",
      district: "",
      city: "",
    });
    setName("");
    setPhone("");
    setEmail("");
    setComments("");
    setSelectedState("");
    setSelectedCity("");
    setShow(false);
  };

  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    email: "",
    state: "",
    district: "",
    city: "",
  });

  const hasErrors = () => {
    return (
      Object.values(errors).some((error) => error !== "") ||
      !name ||
      !phone ||
      !email ||
      !selectedState ||
      !selectedCity
    );
  };

  const handleBlur = (field) => {
    let errorMsg = "";
    switch (field) {
      case "name":
        if (!validateName(name))
          errorMsg = Contents.productPage.enterUserDetailsPopup.nameErrorMsg;
        break;
      case "phone":
        if (!validateMobileNumber(phone))
          errorMsg = Contents.productPage.enterUserDetailsPopup.phoneErrorMsg;
        break;
      case "email":
        if (!validateEmail(email))
          errorMsg = Contents.productPage.enterUserDetailsPopup.emailErrorMsg;
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [field]: errorMsg }));
  };

  const StateOptions = [
    { value: "Andhra Pradesh", label: "Andhra Pradesh" },
    { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
    { value: "Assam", label: "Assam" },
    { value: "Bihar", label: "Bihar" },
    { value: "Chhattisgarh", label: "Chhattisgarh" },
    { value: "Goa", label: "Goa" },
    { value: "Gujarat", label: "Gujarat" },
    { value: "Haryana", label: "Haryana" },
    { value: "Himachal Pradesh", label: "Himachal Pradesh" },
    { value: "Jharkhand", label: "Jharkhand" },
    { value: "Karnataka", label: "Karnataka" },
    { value: "Kerala", label: "Kerala" },
    { value: "Madhya Pradesh", label: "Madhya Pradesh" },
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Manipur", label: "Manipur" },
    { value: "Meghalaya", label: "Meghalaya" },
    { value: "Mizoram", label: "Mizoram" },
    { value: "Nagaland", label: "Nagaland" },
    { value: "Odisha", label: "Odisha" },
    { value: "Punjab", label: "Punjab" },
    { value: "Rajasthan", label: "Rajasthan" },
    { value: "Sikkim", label: "Sikkim" },
    { value: "Tamil Nadu", label: "Tamil Nadu" },
    { value: "Telangana", label: "Telangana" },
    { value: "Tripura", label: "Tripura" },
    { value: "Uttar Pradesh", label: "Uttar Pradesh" },
    { value: "Uttarakhand", label: "Uttarakhand" },
    { value: "West Bengal", label: "West Bengal" },
  ];
  const validateAllFields = () => {
    const newErrors = {};

    // Check for empty fields first and set "Enter this field" error
    if (!name) newErrors.name = "Enter this field";
    else if (!validateName(name))
      newErrors.name = Contents.productPage.enterUserDetailsPopup.nameErrorMsg;

    if (!phone) newErrors.phone = "Enter this field";
    else if (!validateMobileNumber(phone))
      newErrors.phone =
        Contents.productPage.enterUserDetailsPopup.phoneErrorMsg;

    if (!email) newErrors.email = "Enter this field";
    else if (!validateEmail(email))
      newErrors.email =
        Contents.productPage.enterUserDetailsPopup.emailErrorMsg;

    setErrors(newErrors);

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="enter-details-modal"
      >
        <Modal.Header>
          <Modal.Title>Enter Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* First Row: Name and Phone Number */}
            <div className="row mb-3">
              <div className="col">
                <InputComponent
                  id="formName"
                  label={Contents.productPage.enterUserDetailsPopup.name}
                  placeholder={
                    Contents.productPage.enterUserDetailsPopup.enterName
                  }
                  value={name}
                  onChange={(e) => {
                    const newName = e.target.value;
                    setName(newName);

                    if (validateName(newName)) {
                      setErrors((prev) => ({ ...prev, name: "" }));
                    }
                  }}
                  onBlur={() => handleBlur("name")}
                />
                {errors.name && (
                  <span className="error-text">{errors.name}</span>
                )}
              </div>
              <div className="col">
                <InputComponent
                  id="formPhoneNumber"
                  label={Contents.productPage.enterUserDetailsPopup.phone}
                  placeholder={
                    Contents.productPage.enterUserDetailsPopup.enterPhone
                  }
                  value={phone}
                  onChange={(e) => {
                    const newPhone = e.target.value;
                    setPhone(newPhone);

                    // Remove "Enter this field" error if the field is not empty
                    if (newPhone) {
                      setErrors((prev) => ({ ...prev, phone: "" }));
                    } else {
                      // Only show "Enter this field" if the field is still empty
                      if (!newPhone) {
                        setErrors((prev) => ({
                          ...prev,
                          phone: "Enter this field",
                        }));
                      }
                    }

                    // Clear the validation error if the phone is valid
                    if (validateMobileNumber(newPhone)) {
                      setErrors((prev) => ({ ...prev, phone: "" }));
                    }
                  }}
                  onBlur={() => handleBlur("phone")}
                />
                {errors.phone && (
                  <span className="error-text">{errors.phone}</span>
                )}
              </div>
            </div>

            {/* Second Row: Email  */}
            <div className="row mb-3">
              <div className="col">
                <InputComponent
                  id="formEmail"
                  label={Contents.productPage.enterUserDetailsPopup.email}
                  type="email"
                  placeholder={
                    Contents.productPage.enterUserDetailsPopup.enterEmail
                  }
                  value={email}
                  onChange={(e) => {
                    const newEmail = e.target.value;
                    setEmail(newEmail);

                    // Remove "Enter this field" error if the field is not empty
                    if (newEmail) {
                      setErrors((prev) => ({ ...prev, email: "" }));
                    } else {
                      // Only show "Enter this field" if the field is still empty
                      if (!newEmail) {
                        setErrors((prev) => ({
                          ...prev,
                          email: "Enter this field",
                        }));
                      }
                    }

                    if (validateEmail(newEmail)) {
                      setErrors((prev) => ({ ...prev, email: "" }));
                    }
                  }}
                  onBlur={() => handleBlur("email")}
                />
                {errors.email && (
                  <span className="error-text">{errors.email}</span>
                )}
              </div>
            </div>

            {/* Third Row: State and City */}
            <div className="row mb-3">
              <div className="col">
                <SelectComponent
                  label={Contents.productPage.enterUserDetailsPopup.state}
                  options={StateOptions}
                  value={selectedState}
                  onChange={(e) => setSelectedState(e.target.value)}
                  // onBlur={() => handleBlur("state")}
                  placeholder={
                    Contents.productPage.enterUserDetailsPopup.enterState
                  }
                />
                {errors.state && (
                  <span className="error-text">{errors.state}</span>
                )}
              </div>
              <div className="col">
                <InputComponent
                  label={Contents.productPage.enterUserDetailsPopup.city}
                  value={selectedCity}
                  onChange={(e) => setSelectedCity(e.target.value)}
                  onBlur={() => handleBlur("city")}
                  placeholder={
                    Contents.productPage.enterUserDetailsPopup.enterCity
                  }
                />
                {errors.city && (
                  <span className="error-text">{errors.city}</span>
                )}
              </div>
            </div>

            {/* Fourth Row: Comments */}
            <div className="mb-3">
              <Form.Group controlId="formComments">
                <Form.Label>Comments</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder={
                    Contents.productPage.enterUserDetailsPopup.typeHere
                  }
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                />
              </Form.Group>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <ButtonComponent
            type="yellowOutlined"
            variant="rounded"
            buttonText={Contents.productPage.enterUserDetailsPopup.cancel}
            className={"enterDetailsCancelbtn enterDetailsBtn"}
            onClick={handleClose}
          />
          <ButtonComponent
            buttonText={Contents.productPage.enterUserDetailsPopup.submit}
            variant="rounded"
            className={"enterDetailsSubmitbtn enterDetailsBtn"}
            onClick={() => {
              if (validateAllFields()) {
                onClick();
              }
            }}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EnterDetailsPopup;
